import React from 'react'
import QuestionRow from '../CustomInputs/QuestionRow/QuestionRow'

const NewAddressSection = ({ context }) => {
    var policyAddressInfo = context?.addressChangeClass?.newAddress
    policyAddressInfo.state = context?.getStateAbbr(context?.addressChangeClass?.policyState)

    var newAddress = context?.addressChangeClass?.newAddress
    // console.log("New Address", newAddress);
    
    return (
        <>
            <QuestionRow
                label='New Address'
                policyAddressInfo={policyAddressInfo}
                staticField={true}
            />
            <QuestionRow
                label='Date of Move'
                value={newAddress?.dateMoved}
            />
            <QuestionRow
                label='Requested Effective Date'
                value={newAddress?.requestedEffDate}
            />
            <QuestionRow
                label='Will all vehicles on the policy be garaged at the new address overnight?'
                value={newAddress?.garaged == "1" ? "Yes" : "No"}
            />
        </>
    )
}

export default NewAddressSection